import React from 'react';
import WelcomePageComponent from '../vendor-checkin/components/welcome-page/welcome-page.component';

const Home: React.FC = () => {
  return <WelcomePageComponent></WelcomePageComponent>;
};

export default Home;
